'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adPixelUnitSize = exports.prerollVideoAdUnitSizes = exports.prerollVideoAdUnitSizesMap = undefined;

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pixelUnitSizes = {
  width: 1,
  height: 1
};

var prerollVideoAdUnitSizesMap = exports.prerollVideoAdUnitSizesMap = {
  pixel: pixelUnitSizes,
  small: {
    width: 400,
    height: 300
  },
  medium: {
    width: 640,
    height: 360
  },
  large: {
    width: 640,
    height: 480
  }
};

var prerollVideoAdUnitSizes = exports.prerollVideoAdUnitSizes = (0, _map2.default)(prerollVideoAdUnitSizesMap, function (_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width + 'x' + height;
}).join('|');
var adPixelUnitSize = exports.adPixelUnitSize = pixelUnitSizes.width + 'x' + pixelUnitSizes.height;